export default "__VITE_ASSET__DN6eMMpa__"